class AbortedRequestError extends Error {
  public readonly isAbortedRequest = true;
  public readonly code = 'ERR_CANCELED';

  constructor(url?: string) {
    super(`Request aborted${url ? `: ${url}` : ''}`);
    this.name = 'AbortedRequestError';
  }
}

function isAbortedRequestError(error: unknown): error is AbortedRequestError {
  return error instanceof AbortedRequestError || (error as any)?.isAbortedRequest === true;
}

export { AbortedRequestError, isAbortedRequestError };
